// dataContextMenu.ts
import { RIGHTS_LEVEL } from '~src/types/enums';
{
  /* MOVE-TO & PERMISSIONS & SHARE & FOLDER-PROPERTIES: TO BE ADDED BACK WHEN IMPLEMENTED  */
}

export type DataContextMenuItemType<ModalT extends string = string> = {
  key: number;
  icon: string;
  iconStyle: string;
  name: string;
  modal: ModalT;
  minPermissionLevel: RIGHTS_LEVEL | 0;
  needsSU?: boolean;
  onTimeMachine?: boolean;
  isSubMenu?: boolean;
  disabled?: boolean;
  disabledTooltip?: string;
  displayName?: string;
  groupKey?: 'root' | (string & unknown);
};
interface DataType {
  folder: DataContextMenuItemType[];
  file: DataContextMenuItemType[];
  attachment: DataContextMenuItemType[];
  deletedFile: DataContextMenuItemType[];
  deletedAttachment: DataContextMenuItemType[];
  moduleFile: DataContextMenuItemType[];
  folderMobile: DataContextMenuItemType[];
  fileMobile: DataContextMenuItemType[];
  noItemSelected: DataContextMenuItemType[];
  shareKey: DataContextMenuItemType[];
  shareKeyRemoved: DataContextMenuItemType[];
  shareKeyClaimed: DataContextMenuItemType[];
  shareKeyRejected: DataContextMenuItemType[];
  shareKeyReactivated: DataContextMenuItemType[];
  questionAndAnswer: DataContextMenuItemType[];
  answerMenu: DataContextMenuItemType[];
  contractContext: DataContextMenuItemType[];
  vendorContractContext: DataContextMenuItemType[];
  contractGroup: DataContextMenuItemType[];
  contractCard: DataContextMenuItemType[];
  movementsActionMenu: DataContextMenuItemType[];
  movementsActionMenuVendor: DataContextMenuItemType[];
  movementsIgnoredActionMenu: DataContextMenuItemType[];
  primaryPreviewContextItems: DataContextMenuItemType[];
  deletedPrimaryPreviewContextItems: DataContextMenuItemType[];
  leftNavHamburgerMenuCollapsed: DataContextMenuItemType[];
  leftNavHamburgerMenuExpanded: DataContextMenuItemType[];
  offerWinnerContext: DataContextMenuItemType[];
  offerNotWinnerContext: DataContextMenuItemType[];
  deletedContractContext: DataContextMenuItemType[];
  deletedContractGroup: DataContextMenuItemType[];
  deletedContractCard: DataContextMenuItemType[];
  projectTenderRegistrationContext: DataContextMenuItemType[];
  projectBuilderFolder: DataContextMenuItemType[];
}

const data: DataType = {
  folder: [
    // {
    //   key: 0,
    //   icon: 'eye',
    //   iconStyle: 'far',
    //   name: 'open-folder',
    //   modal: 'open-folder',
    //   minPermissionLevel: 0,
    // },
    // {
    //   key: 3,
    //   icon: 'share-square',
    //   iconStyle: 'far',
    //   name: 'share',
    //   modal: 'share',
    //   minPermissionLevel: 0,
    // },
    {
      key: 6,
      icon: 'star',
      iconStyle: 'far',
      name: 'mark-as-favourite',
      modal: 'favourite',
      minPermissionLevel: 0,
    },
    {
      key: 5,
      icon: 'arrow-alt-from-left',
      iconStyle: 'far',
      name: 'move-to',
      modal: 'folder-move',
      minPermissionLevel: RIGHTS_LEVEL.WRITE,
    },
    {
      key: 4,
      icon: 'pen',
      iconStyle: 'far',
      name: 'edit',
      modal: 'folder-edit',
      minPermissionLevel: RIGHTS_LEVEL.WRITE,
    },
    {
      key: 9,
      icon: 'highlighter-line',
      iconStyle: 'far',
      name: 'highlight',
      modal: 'folder-focus',
      minPermissionLevel: RIGHTS_LEVEL.WRITE,
      isSubMenu: true,
    },
    {
      key: 10,
      icon: '',
      iconStyle: '',
      name: 'add-to-tender',
      modal: 'folder-tender',
      minPermissionLevel: RIGHTS_LEVEL.WRITE,
    },
    // {
    //   key: 8,
    //   icon: 'info-circle',
    //   iconStyle: 'far',
    //   name: 'folder-properties',
    //   modal: 'folder-properties',
    //   minPermissionLevel: 0,
    // },
    // {
    //   key: 2,
    //   icon: 'file-user',
    //   iconStyle: 'far',
    //   name: 'rights-managment',
    //   modal: 'rights-managment',
    //   minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    // },
    {
      key: 1,
      icon: 'file-download',
      iconStyle: 'far',
      name: 'download',
      modal: 'folder-download',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
      onTimeMachine: true,
    },
    {
      key: 7,
      icon: 'trash',
      iconStyle: 'far',
      name: 'delete',
      modal: 'delete',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
    {
      key: 8,
      icon: 'file-alt',
      iconStyle: 'far',
      name: 'log',
      modal: 'item-log',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
    },
  ],

  file: [
    // {
    //   key: 0,
    //   icon: 'eye',
    //   iconStyle: 'far',
    //   name: 'view-file',
    //   modal: 'view-file',
    //   minPermissionLevel: 0,
    // },
    {
      key: 0,
      icon: 'autodesk',
      iconStyle: 'far',
      name: 'svf-view-file',
      modal: 'svf-view-file',
      minPermissionLevel: 0,
      isSubMenu: true,
      onTimeMachine: true,
    },
    {
      key: 3,
      icon: 'share-square',
      iconStyle: 'far',
      name: 'share',
      modal: 'share',
      minPermissionLevel: 0,
      needsSU: true,
    },

    {
      key: 6,
      icon: 'star',
      iconStyle: 'far',
      name: 'mark-as-favourite',
      modal: 'favourite',
      minPermissionLevel: 0,
    },
    // {
    //   key: 2,
    //   icon: 'history',
    //   iconStyle: 'far',
    //   name: 'file-version',
    //   modal: 'file-version',
    //   minPermissionLevel: 0,
    // },
    {
      key: 5,
      icon: 'arrow-alt-from-left',
      iconStyle: 'far',
      name: 'move-to',
      modal: 'file-move',
      minPermissionLevel: RIGHTS_LEVEL.WRITE,
    },
    {
      key: 4,
      icon: 'pen',
      iconStyle: 'far',
      name: 'edit',
      modal: 'file-edit',
      minPermissionLevel: RIGHTS_LEVEL.WRITE,
    },
    {
      key: 1,
      icon: 'file-download',
      iconStyle: 'far',
      name: 'download',
      modal: 'file-download',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
      onTimeMachine: true,
    },
    {
      key: 7,
      icon: 'trash',
      iconStyle: 'far',
      name: 'delete',
      modal: 'delete',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
    {
      key: 8,
      icon: 'file-alt',
      iconStyle: 'far',
      name: 'log',
      modal: 'item-log',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
    },
  ],
  attachment: [
    // {
    //   key: 0,
    //   icon: 'eye',
    //   iconStyle: 'far',
    //   name: 'view-file',
    //   modal: 'view-file',
    //   minPermissionLevel: 0,
    // },
    /*  {
      key: 3,
      icon: 'share-square',
      iconStyle: 'far',
      name: 'share',
      modal: 'share',
      minPermissionLevel: 0,
      needsSU: true,
    }, */

    /*     {
      key: 6,
      icon: 'star',
      iconStyle: 'far',
      name: 'mark-as-favourite',
      modal: 'favourite',
      minPermissionLevel: 0,
    }, */
    // {
    //   key: 2,
    //   icon: 'history',
    //   iconStyle: 'far',
    //   name: 'file-version',
    //   modal: 'file-version',
    //   minPermissionLevel: 0,
    // },
    /*    {
      key: 5,
      icon: 'arrow-alt-from-left',
      iconStyle: 'far',
      name: 'move-to',
      modal: 'file-move',
      minPermissionLevel: RIGHTS_LEVEL.WRITE,
    }, */
    {
      key: 4,
      icon: 'pen',
      iconStyle: 'far',
      name: 'edit-attachment',
      modal: 'edit-attachment',
      minPermissionLevel: RIGHTS_LEVEL.WRITE,
    },
    {
      key: 1,
      icon: 'file-download',
      iconStyle: 'far',
      name: 'download',
      modal: 'file-download',
      minPermissionLevel: 0,
      onTimeMachine: true,
    },
    {
      key: 7,
      icon: 'trash',
      iconStyle: 'far',
      name: 'delete',
      modal: 'delete',
      minPermissionLevel: 0,
    },
    /*     {
      key: 8,
      icon: 'file-alt',
      iconStyle: 'far',
      name: 'log',
      modal: 'item-log',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
    }, */
  ],
  deletedFile: [
    {
      key: 0,
      icon: 'autodesk',
      iconStyle: 'far',
      name: 'svf-view-file',
      modal: 'svf-view-file',
      minPermissionLevel: 0,
      isSubMenu: true,
    },
    {
      key: 1,
      icon: 'eye',
      iconStyle: 'far',
      name: 'view-file',
      modal: 'view-file',
      minPermissionLevel: 0,
      needsSU: true,
    },
    {
      key: 2,
      icon: 'pen',
      iconStyle: 'far',
      name: 'edit',
      modal: 'file-edit',
      minPermissionLevel: 0,
      needsSU: true,
    },
    {
      key: 2,
      icon: 'file-download',
      iconStyle: 'far',
      name: 'download',
      modal: 'file-download',
      minPermissionLevel: 0,
      needsSU: true,
    },
    {
      key: 3,
      icon: 'trash-restore',
      iconStyle: 'far',
      name: 'restore',
      modal: 'restore',
      minPermissionLevel: 0,
      needsSU: true,
    },
    // {
    //   key: 4,
    //   icon: 'trash-restore',
    //   iconStyle: 'far',
    //   name: 'restore-to',
    //   modal: 'restore-to',
    //   minPermissionLevel: RIGHTS_LEVEL.SUPER_USER,
    //   needsSU: true,
    // },
  ],
  deletedAttachment: [
    /*    {
      key: 0,
      icon: 'eye',
      iconStyle: 'far',
      name: 'view-file',
      modal: 'view-file',
      minPermissionLevel: 0,
      needsSU: true,
    },
    {
      key: 1,
      icon: 'pen',
      iconStyle: 'far',
      name: 'edit',
      modal: 'file-edit',
      minPermissionLevel: 0,
      needsSU: true,
    }, */
    {
      key: 3,
      icon: 'file-download',
      iconStyle: 'far',
      name: 'download',
      modal: 'file-download',
      minPermissionLevel: 0,
      needsSU: true,
    },
    {
      key: 4,
      icon: 'trash-restore',
      iconStyle: 'far',
      name: 'restore',
      modal: 'restore',
      minPermissionLevel: 0,
      needsSU: true,
    },
    // {
    //   key: 4,
    //   icon: 'trash-restore',
    //   iconStyle: 'far',
    //   name: 'restore-to',
    //   modal: 'restore-to',
    //   minPermissionLevel: RIGHTS_LEVEL.SUPER_USER,
    //   needsSU: true,
    // },
  ],
  moduleFile: [
    {
      key: 1,
      icon: 'file-download',
      iconStyle: 'far',
      name: 'download',
      modal: 'module-file-download',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
    },
  ],
  folderMobile: [
    {
      key: 1,
      icon: 'star',
      iconStyle: 'far',
      name: 'mark-as-favourite',
      modal: 'favourite',
      minPermissionLevel: 0,
    },
    {
      key: 2,
      icon: 'pen',
      iconStyle: 'far',
      name: 'edit',
      modal: 'folder-edit',
      minPermissionLevel: RIGHTS_LEVEL.WRITE,
    },
    {
      key: 3,
      icon: 'trash',
      iconStyle: 'far',
      name: 'delete',
      modal: 'delete',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
  ],
  fileMobile: [
    {
      key: 0,
      icon: 'autodesk',
      iconStyle: 'far',
      name: 'svf-view-file',
      modal: 'svf-view-file',
      minPermissionLevel: 0,
      isSubMenu: false,
    },
    {
      key: 1,
      icon: 'star',
      iconStyle: 'far',
      name: 'mark-as-favourite',
      modal: 'favourite',
      minPermissionLevel: 0,
    },
    {
      key: 2,
      icon: 'pen',
      iconStyle: 'far',
      name: 'edit',
      modal: 'file-edit',
      minPermissionLevel: RIGHTS_LEVEL.WRITE,
    },
    {
      key: 3,
      icon: 'file-download',
      iconStyle: 'far',
      name: 'download',
      modal: 'file-download',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
    },
    {
      key: 4,
      icon: 'trash',
      iconStyle: 'far',
      name: 'delete',
      modal: 'delete',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
  ],
  noItemSelected: [
    {
      key: 1,
      icon: 'folder-plus',
      iconStyle: 'far',
      name: 'create-folder',
      modal: 'folder-create',
      minPermissionLevel: RIGHTS_LEVEL.WRITE,
    },
    {
      key: 2,
      icon: 'file-upload',
      iconStyle: 'far',
      name: 'upload-files',
      modal: 'upload-files',
      minPermissionLevel: RIGHTS_LEVEL.WRITE,
    },
  ],

  // Share Key
  shareKey: [
    // JIRA: Vendor tab: Remove details
    // {
    //   key: 0,
    //   icon: 'memo',
    //   iconStyle: 'far',
    //   name: 'details-log',
    //   modal: 'details-log',
    //   minPermissionLevel: RIGHTS_LEVEL.WRITE,
    // },
    // {
    //   key: 1,
    //   icon: 'pen',
    //   iconStyle: 'far',
    //   name: 'edit',
    //   modal: 'edit',
    //   minPermissionLevel: RIGHTS_LEVEL.WRITE,
    // },
    // {
    //   key: 2,
    //   icon: 'envelope',
    //   iconStyle: 'far',
    //   name: 'offer-resend-invite',
    //   modal: 'resend-invite',
    //   minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    // },
    {
      key: 3,
      icon: 'pen',
      iconStyle: 'far',
      name: 'edit-invite',
      modal: 'edit-invite',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
    {
      key: 4,
      icon: 'trash',
      iconStyle: 'far',
      name: 'delete',
      modal: 'delete',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
    // {
    //   key: 5,
    //   icon: 'square-plus',
    //   iconStyle: 'far',
    //   name: 'add-to-vendors',
    //   modal: 'add-to-vendors',
    //   minPermissionLevel: RIGHTS_LEVEL.OPEN,
    // },
    // {
    //   key: 6,
    //   icon: 'user-check',
    //   iconStyle: 'far',
    //   name: 'edit-vendor',
    //   modal: 'edit-vendor',
    //   minPermissionLevel: RIGHTS_LEVEL.OPEN,
    // },
    // {
    //   key: 7,
    //   icon: 'envelope',
    //   iconStyle: 'far',
    //   name: 'vendor-details',
    //   modal: 'vendor-details',
    //   minPermissionLevel: RIGHTS_LEVEL.OPEN,
    // },
  ],
  shareKeyRemoved: [
    // JIRA: Vendor tab: Remove details
    // {
    //   key: 0,
    //   icon: 'memo',
    //   iconStyle: 'far',
    //   name: 'details-log',
    //   modal: 'details-log',
    //   minPermissionLevel: RIGHTS_LEVEL.WRITE,
    // },
    {
      key: 1,
      icon: 'pen',
      iconStyle: 'far',
      name: 'edit',
      modal: 'edit',
      minPermissionLevel: RIGHTS_LEVEL.WRITE,
    },
    {
      key: 2,
      icon: 'repeat',
      iconStyle: 'far',
      name: 'reactivate',
      modal: 'reactivate',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
    // {
    //   key: 2,
    //   icon: 'envelope',
    //   iconStyle: 'far',
    //   name: 'offer-resend-invite',
    //   modal: 'resend-invite',
    //   minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    // },
  ],
  shareKeyClaimed: [
    {
      key: 0,
      icon: 'circle-plus',
      iconStyle: 'far',
      name: 'claim',
      modal: 'claim',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
  ],
  shareKeyRejected: [
    {
      key: 0,
      icon: 'circle-xmark',
      iconStyle: 'far',
      name: 'reject',
      modal: 'reject',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
  ],
  questionAndAnswer: [
    {
      key: 1,
      icon: 'history',
      iconStyle: 'far',
      name: 'messages-history',
      modal: 'messages-history',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
      groupKey: 'root',
    },
    {
      key: 0,
      icon: 'archive',
      iconStyle: 'far',
      name: 'revise-and-accept',
      modal: 'revise-and-accept',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
      groupKey: 'qa-features',
    },
    {
      key: 2,
      icon: 'check',
      iconStyle: 'far',
      name: 'accept',
      modal: 'accept',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
      groupKey: 'qa-features',
    },
    {
      key: 3,
      icon: 'pen',
      iconStyle: 'far',
      name: 'answer',
      modal: 'answer',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
      groupKey: 'qa-features',
    },
    {
      key: 4,
      icon: 'ban',
      iconStyle: 'far',
      name: 'reject',
      modal: 'reject',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
      groupKey: 'qa-features',
    },
    {
      key: 5,
      icon: 'trash',
      iconStyle: 'far',
      name: 'ignore',
      modal: 'ignore',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
      groupKey: 'correctional-letter',
    },
    {
      key: 6,
      icon: 'repeat',
      iconStyle: 'far',
      name: 'reactivate',
      modal: 'reactivate',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
      groupKey: 'correctional-letter',
    },
    {
      key: 7,
      icon: 'file-alt',
      iconStyle: 'far',
      name: 'add-to-correction-letter',
      modal: 'add-to-correction-letter',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
      groupKey: 'correctional-letter',
    },
    {
      key: 8,
      icon: 'file-minus',
      iconStyle: 'far',
      name: 'remove-from-correction-letter',
      modal: 'remove-from-correction-letter',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
      groupKey: 'correctional-letter',
    },
  ],
  answerMenu: [
    {
      key: 0,
      icon: 'trash',
      iconStyle: 'far',
      name: 'remove',
      modal: 'remove',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
    {
      key: 1,
      icon: 'ban',
      iconStyle: 'far',
      name: 'reject',
      modal: 'reject',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
    {
      key: 2,
      icon: 'trash-restore',
      iconStyle: 'far',
      name: 'restore',
      modal: 'restore',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
    {
      key: 3,
      icon: 'eye',
      iconStyle: 'far',
      name: 'show-deleted-content',
      modal: 'show_deleted_content',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
  ],
  contractContext: [
    {
      key: 0,
      icon: 'trash',
      iconStyle: 'far',
      name: 'delete',
      modal: 'delete',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
    {
      key: 1,
      icon: 'pen',
      iconStyle: 'far',
      name: 'edit',
      modal: 'edit-contract',
      minPermissionLevel: 0,
    },
  ],
  deletedContractContext: [
    {
      key: 0,
      icon: 'repeat',
      iconStyle: 'far',
      name: 'reactivate',
      modal: 'reactivate-contract',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
    // {
    //   key: 1,
    //   icon: 'pen',
    //   iconStyle: 'far',
    //   name: 'edit',
    //   modal: 'edit-contract',
    //   minPermissionLevel: 0,
    // },
  ],
  vendorContractContext: [
    {
      key: 0,
      icon: 'check-circle',
      iconStyle: 'far',
      name: 'finalize-offer',
      modal: 'finalize-offer',
      minPermissionLevel: 0,
    },
    {
      key: 1,
      icon: 'redo',
      iconStyle: 'far',
      name: 'reopen-offer',
      modal: 'reopen-offer',
      minPermissionLevel: 0,
    },
    {
      key: 2,
      icon: 'ban',
      iconStyle: 'far',
      name: 'reject',
      modal: 'reject-offer',
      minPermissionLevel: 0,
    },
  ],
  contractGroup: [
    {
      key: 0,
      icon: 'trash',
      iconStyle: 'far',
      name: 'delete',
      modal: 'delete',
      minPermissionLevel: 0,
    },
    {
      key: 1,
      icon: 'square-plus',
      iconStyle: 'far',
      name: 'add-voucher-to-group',
      modal: 'add-card',
      minPermissionLevel: 0,
    },
    {
      key: 2,
      icon: 'pen',
      iconStyle: 'far',
      name: 'edit',
      modal: 'edit-group',
      minPermissionLevel: 0,
    },
  ],
  contractCard: [
    {
      key: 0,
      icon: 'trash',
      iconStyle: 'far',
      name: 'delete',
      modal: 'delete',
      minPermissionLevel: 0,
    },
    // {
    //   key: 1,
    //   icon: 'square-plus',
    //   iconStyle: 'far',
    //   name: 'add-file',
    //   modal: 'add-file',
    //   minPermissionLevel: 0,
    // },
    {
      key: 2,
      icon: 'pen',
      iconStyle: 'far',
      name: 'edit',
      modal: 'edit-card',
      minPermissionLevel: 0,
    },
  ],
  deletedContractGroup: [
    {
      key: 0,
      icon: 'repeat',
      iconStyle: 'far',
      name: 'reactivate',
      modal: 'reactivate-group',
      minPermissionLevel: 0,
    },
    // {
    //   key: 1,
    //   icon: 'pen',
    //   iconStyle: 'far',
    //   name: 'edit',
    //   modal: 'edit-group',
    //   minPermissionLevel: 0,
    // },
  ],
  deletedContractCard: [
    {
      key: 0,
      icon: 'repeat',
      iconStyle: 'far',
      name: 'reactivate',
      modal: 'reactivate-card',
      minPermissionLevel: 0,
    },
    // {
    //   key: 1,
    //   icon: 'pen',
    //   iconStyle: 'far',
    //   name: 'edit',
    //   modal: 'edit-card',
    //   minPermissionLevel: 0,
    // },
  ],
  shareKeyReactivated: [],
  movementsActionMenu: [
    {
      key: 0,
      icon: 'memo',
      iconStyle: 'far',
      name: 'details-log',
      modal: 'details-log',
      minPermissionLevel: 0,
    },
    {
      key: 1,
      icon: 'pen',
      iconStyle: 'far',
      name: 'add-custom-to-movements',
      modal: 'add-custom-to-movements',
      minPermissionLevel: 0,
    },
    {
      key: 2,
      icon: 'file-alt',
      iconStyle: 'far',
      name: 'add-to-correction-letter',
      modal: 'add-to-correction-letter',
      minPermissionLevel: 0,
      groupKey: 'correctional-letter',
    },
    {
      key: 3,
      icon: 'file-minus',
      iconStyle: 'far',
      name: 'remove-from-correction-letter',
      modal: 'remove-from-correction-letter',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
      groupKey: 'correctional-letter',
    },
    {
      key: 4,
      icon: 'trash',
      iconStyle: 'far',
      name: 'ignore',
      modal: 'ignore-movement',
      minPermissionLevel: 0,
      groupKey: 'correctional-letter',
    },
    {
      key: 5,
      icon: 'repeat',
      iconStyle: 'far',
      name: 'reactivate',
      modal: 'reactivate-movement',
      minPermissionLevel: 0,
      groupKey: 'correctional-letter',
    },
  ],
  movementsActionMenuVendor: [
    {
      key: 0,
      icon: 'memo',
      iconStyle: 'far',
      name: 'details-log',
      modal: 'details-log',
      minPermissionLevel: 0,
    },
  ],
  movementsIgnoredActionMenu: [
    {
      key: 0,
      icon: 'memo',
      iconStyle: 'far',
      name: 'details-log',
      modal: 'details-log',
      minPermissionLevel: 0,
    },
    {
      key: 1,
      icon: 'pen',
      iconStyle: 'far',
      name: 'add-custom-to-movements',
      modal: 'add-custom-to-movements',
      minPermissionLevel: 0,
    },
    {
      key: 2,
      icon: 'repeat',
      iconStyle: 'far',
      name: 'reactivate-movement',
      modal: 'reactivate-movement',
      minPermissionLevel: 0,
    },
  ],

  primaryPreviewContextItems: [
    {
      key: 0,
      icon: 'trash',
      iconStyle: 'far',
      name: 'delete-primary-preview',
      modal: 'delete-primary-preview',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
      needsSU: true,
      isSubMenu: false,
    },
    {
      key: 1,
      icon: 'file-alt',
      iconStyle: 'far',
      name: 'details-primary-preview',
      modal: 'details-primary-preview',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
      needsSU: true,
      isSubMenu: false,
    },
  ],
  deletedPrimaryPreviewContextItems: [
    {
      key: 0,
      icon: 'file-alt',
      iconStyle: 'far',
      name: 'details-primary-preview',
      modal: 'details-primary-preview',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
      needsSU: true,
      isSubMenu: false,
    },
  ],
  leftNavHamburgerMenuExpanded: [
    {
      key: 0,
      icon: 'angles-left',
      iconStyle: 'far',
      name: 'collapse-navigation',
      modal: 'leftnav-toggle',
      minPermissionLevel: 0,
      isSubMenu: false,
    },
    {
      key: 1,
      icon: 'home',
      iconStyle: 'far',
      name: 'go-to-dashboard',
      modal: 'leftnav-dashboard',
      minPermissionLevel: 0,
      isSubMenu: false,
    },
    {
      key: 2,
      icon: 'diagram-project',
      iconStyle: 'far',
      name: 'back-to-projects-list',
      modal: 'leftnav-back-projects',
      minPermissionLevel: 0,
      isSubMenu: false,
    },
    {
      key: 3,
      icon: 'arrow-left',
      iconStyle: 'fas',
      name: 'back-one-level',
      modal: 'leftnav-back-one',
      minPermissionLevel: 0,
      isSubMenu: false,
    },
  ],
  leftNavHamburgerMenuCollapsed: [
    {
      key: 0,
      icon: 'angles-right',
      iconStyle: 'far',
      name: 'expand-navigation',
      modal: 'leftnav-toggle',
      minPermissionLevel: 0,
      isSubMenu: false,
    },
    {
      key: 1,
      icon: 'home',
      iconStyle: 'far',
      name: 'go-to-dashboard',
      modal: 'leftnav-dashboard',
      minPermissionLevel: 0,
      isSubMenu: false,
    },
    {
      key: 2,
      icon: 'diagram-project',
      iconStyle: 'far',
      name: 'back-to-projects-list',
      modal: 'leftnav-back-projects',
      minPermissionLevel: 0,
      isSubMenu: false,
    },
    {
      key: 3,
      icon: 'arrow-left',
      iconStyle: 'fas',
      name: 'back-one-level',
      modal: 'leftnav-back-one',
      minPermissionLevel: 0,
      isSubMenu: false,
    },
  ],
  offerWinnerContext: [
    {
      key: 0,
      icon: 'times-circle',
      iconStyle: 'far',
      name: 'remove-winner',
      modal: 'remove-winner',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
  ],
  offerNotWinnerContext: [
    {
      key: 0,
      icon: 'trophy',
      iconStyle: 'far',
      name: 'set-as-winner',
      modal: 'set-winner',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
  ],
  projectTenderRegistrationContext: [
    {
      key: 0,
      icon: 'memo',
      iconStyle: 'far',
      name: 'tab-details',
      modal: 'tender-details',
      minPermissionLevel: RIGHTS_LEVEL.OPEN,
    },
    {
      key: 1,
      icon: 'globe',
      iconStyle: 'far',
      name: 'publication',
      modal: 'publication',
      minPermissionLevel: RIGHTS_LEVEL.MANAGE,
    },
  ],
  projectBuilderFolder: [
    {
      key: 0,
      icon: 'folder-plus',
      iconStyle: 'far',
      name: 'create-child-folder',
      modal: 'create-child-folder',
      minPermissionLevel: 0,
    },
    {
      key: 1,
      icon: 'pen',
      iconStyle: 'far',
      name: 'edit',
      modal: 'edit-folder',
      minPermissionLevel: 0,
    },
    {
      key: 2,
      icon: 'trash',
      iconStyle: 'far',
      name: 'remove',
      modal: 'remove-folder',
      minPermissionLevel: 0,
    },
    {
      key: 3,
      icon: 'arrow-alt-from-left',
      iconStyle: 'far',
      name: 'move-to',
      modal: 'move-folder',
      minPermissionLevel: 0,
    },
    {
      key: 4,
      icon: 'arrow-alt-to-right',
      iconStyle: 'far',
      name: 'grap',
      modal: 'import-to-folder',
      minPermissionLevel: 0,
    },
    {
      key: 5,
      icon: 'folder-upload',
      iconStyle: 'far',
      name: 'import-from-template',
      modal: 'import-template-to-folder',
      minPermissionLevel: 0,
    },
  ],
};

export default data;
